var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('router-link',{attrs:{"to":`/invoices/transactions/view/${_vm.params.value}`}},[_c('feather-icon',{attrs:{"icon":"EyeIcon","svgClasses":"h-5 w-5 hover:text-danger cursor-pointer"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }